import { useState } from 'react';
import type { VesselAlert } from '../types/vesselChanges';
import { VesselAlertRow } from './VesselAlertRow';
import { VesselLinkAlertRow } from './VesselLinkAlertRow';
import { FOCUS_RING } from './rowStyles';

/** Rows shown before "Show all N". */
const FIRST_ROWS = 5;

/** "Action needed": open vessel alerts (mine first, as the server sends them) pinned above the notices until handled. */
export const VesselAlertList = ({ alerts, onOpen }: { alerts: VesselAlert[]; onOpen: (path: string) => void }) => {
  const [showAll, setShowAll] = useState(false);
  if (alerts.length === 0) return null;
  const shown = showAll ? alerts : alerts.slice(0, FIRST_ROWS);

  return (
    <section aria-label="Action needed" className="border-b border-slate-100">
      <h3 className="px-3 pb-1 pt-2 text-[11px] font-medium text-slate-500">Action needed</h3>
      <ul className="divide-y divide-slate-100">
        {shown.map((alert) => (alert.kind === 'LINK'
          ? <VesselLinkAlertRow key={alert.id} alert={alert} onOpen={onOpen} />
          : <VesselAlertRow key={alert.id} alert={alert} onOpen={onOpen} />))}
      </ul>
      {alerts.length > FIRST_ROWS && (
        <button
          type="button"
          aria-expanded={showAll}
          onClick={() => setShowAll((value) => !value)}
          className={`w-full px-3 py-1.5 text-left text-[11px] font-medium text-blue-700 hover:bg-slate-50 ${FOCUS_RING}`}
        >
          {showAll ? 'Show fewer' : `Show all ${alerts.length}`}
        </button>
      )}
    </section>
  );
};
